import angular from 'angular';

/**
 * Controller for managing a group of question items.
 * This controller handles the initialization, loading, and saving of question item groups.
 */
class QuestionItemGroupController {
    /**
     * Creates an instance of QuestionItemGroupController.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} $q - The AngularJS promise service.
     * @param {Object} $timeout - The AngularJS timeout service.
     * @param {Object} QuestionItemGroupService - The service for managing question item groups.
     */
    constructor($scope, $q, $timeout, QuestionItemGroupService) {
        'ngInject';
        this.$scope = $scope;
        this.$q = $q;
        this.$timeout = $timeout;
        this.QuestionItemGroupService = QuestionItemGroupService;
        this.init();
    }

    /**
     * Initializes the controller by setting up initial state and loading the question item group.
     */
    init() {
        this.questionItemGroup = null;
        this.loading = true;
        this.loadQuestionItemGroup();
    }

    /**
     * Loads the question item group from the service.
     * Sets the question item group and updates the loading state.
     */
    loadQuestionItemGroup() {
        this.QuestionItemGroupService.get().then(response => {
            this.questionItemGroup = response.data;
            this.loading = false;
            this.$scope.$apply(); // SMELL: Forcing scope apply can lead to performance issues. Consider refactoring.
        });
    }

    /**
     * Saves the current question item group using the service.
     * Updates the loading state after the save operation.
     */
    saveQuestionItemGroup() {
        this.loading = true;
        this.QuestionItemGroupService.save(this.questionItemGroup).then(() => {
            this.loading = false;
            this.$scope.$apply(); // SMELL: Forcing scope apply can lead to performance issues. Consider refactoring.
        });
    }
}

export default QuestionItemGroupController;